import { observer } from 'mobx-react-lite';
import Tooltip from '@/ui/tooltip';
import QrcodeShare from '@/components/qrcode-share';
import copy from 'copy-to-clipboard';
import Other from '@/common/helper/other';

const AgentShare = observer((props) => {
  const {
    small,
    shareUrl
  } = props

  return (
    <Tooltip 
      title={
        <QrcodeShare url={shareUrl} />
      } 
      color="white"
      placement="bottomLeft"
      arrow={false}
      getPopupContainer={node => node}
      destroyTooltipOnHide
    >
      <div 
        className={[
          'h-32px flex items-center justify-center rounded-full border-1px border-black border-opacity-16 border-solid bg-button-bg-normal hover:bg-[#f7f7f7] cursor-pointer',
          small ? 'w-32px' : 'px-16px py-8px',
          small ? 'rounded-full' : 'rounded-16px',
        ]}
        onClick={() => {
          const copied = copy(shareUrl);
          copied && Other.toast('分享链接已复制', "success");
        }}
        // className={`h-32px box-border flex items-center gap-6px rounded-full border-1px border-black border-opacity-16 border-solid px-12px bg-button-bg-normal hover:bg-[#f7f7f7] cursor-pointer`}
      >
        <img 
          src="https://p1.ssl.qhimg.com/t110b9a9301aa0ef66759fd7023.png" 
          className={`size-16px ${small ? 'mx-0' : 'mr-6px'}`}
          alt="" 
        />
        {
          !small && (
            <div className='text-14px text-black'>分享</div>
          )
        }
      </div>
    </Tooltip>
  )
})

export default AgentShare